import { inject, Injectable } from "@angular/core";
import { GoogleTagManagerService } from "angular-google-tag-manager";
import {
  LocalStorageService,
  StorageKeys,
} from "../services/local-storage.service";
import { GtmFactory } from "./gtm.factory";

@Injectable()
export class GtmService {
  private readonly localStorageService = inject(LocalStorageService);
  private readonly googleTagManagerService = inject(GoogleTagManagerService);
  private readonly gtmFactory = inject(GtmFactory);

  public setUserIsEmployee(): void {
    const isUserEmployee = this.localStorageService.get(
      StorageKeys.IsUserEmployee,
    );

    if (isUserEmployee === "true") {
      return;
    }

    this.localStorageService.store(StorageKeys.IsUserEmployee, "true");
  }

  public isReloadNeeded(): boolean {
    const gtmId = this.gtmFactory.getGtmId();
    const currentGtmId = this.googleTagManagerService.googleTagManagerId;

    return gtmId !== currentGtmId;
  }
}
